import { TEMPLATES_REQUEST_LIMIT } from 'templates/pages/Categories/constants';
import { MasonryDataType } from '../stores/types';

type GetPaginationInfoArgs = {
  masonryData: MasonryDataType;
  limit?: number;
};

const getPaginationInfo = ({
  masonryData,
  limit = TEMPLATES_REQUEST_LIMIT,
}: GetPaginationInfoArgs) => {
  const total = masonryData.total || masonryData.pages * limit || masonryData.data.length;

  const pagesCount = Math.ceil(total / limit);

  return {
    total,
    pagesCount,
  };
};

export default getPaginationInfo;
